<template>
  <div id="tramiteInicio">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex xs12>
          <h4 class="grey--text text--darken-1">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon small color="primary">drag_indicator</v-icon>
              </template>
              <span>Menú Principal</span>
            </v-tooltip>Trámite / Nuevo
          </h4>
          <!-- <v-btn
            outline
            color="primary"
            @click="formularioCctp"
            class="mt-3"
          >
            Imprimir Formulario
          </v-btn> -->
        </v-flex>
        <v-spacer></v-spacer>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12 v-if="this.datos.devolucion == 1">
          <v-card>
            <v-card-text>
              <h3>Observación</h3>
              <p>{{ observacion }}</p>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <v-card class="mb-3">
        <v-card-text>
          <v-select
            label="Tipo de tramites"
            :items="tipos_tramite"
            item-value="id"
            item-text="descripcion"
            v-model="datos.tipo_tramite"
            @change="changeTipoTramite()"
            multiple
            chips
            :rules="[v => !!v || 'Seleccione una opción']"
          ></v-select>
        </v-card-text>
      </v-card>
      <datos-centro v-if="datos.tipo_tramite.length == 0"></datos-centro>
      <v-form ref="form_datos">
        <v-card class="mb-3" v-if="datos.tipo_tramite.includes(2)">
          <v-card-title>
            <span class="title font-weight-bold blue--text text--darken-3">Ratificación</span>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 sm6>
                <h3 class="grey--text text--darken-1">Sede Central</h3>
                <v-switch
                  :label="'Ratificar: '+(datos.ratificacion.central.ratificar?'Si':'No')"
                  v-model="datos.ratificacion.central.ratificar"
                  class="mt-1"
                ></v-switch>
                <!-- <v-data-table
                  :headers="headerCurso"
                  :items="datos.ratificacion.central.cursos"
                  class="elevation-1"
                  no-data-text="No existen registros"
                  hide-actions
                >
                  <template v-slot:items="props">
                    <td>{{ props.index + 1 }}</td>
                    <td>{{ props.item.curso_nombre }}</td>
                    <td>{{ props.item.carga_horaria }}</td>
                    <td>{{ props.item.tiempo }}</td>
                    <td>
                      <v-btn-toggle>
                        <v-btn
                          v-if="props.item.turno_m"
                          small
                          class="transparent"
                        >
                          Mañana
                        </v-btn>
                        <v-btn
                          v-if="props.item.turno_t"
                          small
                          class="transparent"
                        >
                          Tarde
                        </v-btn>
                        <v-btn
                          v-if="props.item.turno_n"
                          small
                          class="transparent"
                        >
                          Noche
                        </v-btn>
                      </v-btn-toggle>
                    </td>
                  </template>
                </v-data-table> -->
              </v-flex>
              <v-flex xs12 sm6>
                <h3 class="grey--text text--darken-1">Subsede(s)</h3>
                <div v-if="datos.ratificacion.subsede.length > 0">
                  <v-switch
                    v-for="(item, index) in datos.ratificacion.subsede" :key="index"
                    :label="'Ratificar '+item.institucioneducativa+': '+(item.ratificar?'Si':'No')"
                    v-model="item.ratificar"
                    class="mt-1"
                  ></v-switch>
                </div>
                <div v-else>
                  <h4 class="red--text text--lighten-1">No existen subsede</h4>
                </div>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
        <v-card class="mb-3" v-if="datos.tipo_tramite.includes(3)">
          <v-card-title>
            <span class="title font-weight-bold blue--text text--darken-3">Ampliación</span>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                <h3 class="grey--text text--darken-1">Sede Central</h3>
                <v-switch
                  :label="'Ampliar: '+(datos.ampliacion.central.ampliar?'Si':'No')"
                  v-model="datos.ampliacion.central.ampliar"
                  class="mt-1"
                ></v-switch>
                <div v-if="datos.ampliacion.central.ampliar">
                  <v-card-title class="grey lighten-4 pa-1">
                    <h4 class="grey--text text--darken-1">Curso de Capacitación</h4>
                    <v-spacer></v-spacer>
                    <v-btn
                      flat
                      small
                      outline
                      color="primary my-0"
                      @click="showDialogCurso(-1)"
                    >
                      Agregar Curso
                    </v-btn>
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-data-table
                    :headers="headerCurso"
                    :items="datos.ampliacion.central.cursos"
                    class="elevation-1 mb-3"
                    no-data-text="No existen registros"
                    hide-actions
                  >
                    <template v-slot:items="props">
                      <td>{{ props.index + 1 }}</td>
                      <td>{{ props.item.curso_nombre }}</td>
                      <td>{{ props.item.carga_horaria }}</td>
                      <td>{{ props.item.tiempo }}</td>
                      <td>
                        <v-btn-toggle>
                          <v-btn
                            v-if="props.item.turno_m"
                            small
                            class="transparent"
                          >
                            Mañana
                          </v-btn>
                          <v-btn
                            v-if="props.item.turno_t"
                            small
                            class="transparent"
                          >
                            Tarde
                          </v-btn>
                          <v-btn
                            v-if="props.item.turno_n"
                            small
                            class="transparent"
                          >
                            Noche
                          </v-btn>
                        </v-btn-toggle>
                      </td>
                      <td>
                        <v-tooltip bottom>
                          <template v-slot:activator="{on}">
                            <v-btn v-if="props.item.eliminar"
                              v-on="on"
                              icon
                              dark
                              small
                              color="red"
                              @click="removeCurso(-1, props.index, 1)"
                            >
                              <v-icon small>delete</v-icon>
                            </v-btn>
                          </template>
                          <span>Quitar registro</span>
                        </v-tooltip>
                      </td>
                    </template>
                  </v-data-table>
                </div>
              </v-flex>
              <v-flex xs12>
                <h3 class="grey--text text--darken-1">Subsede(s)</h3>
                <div v-for="(item, indexss) in datos.ampliacion.subsede" :key="indexss">
                  <v-switch
                    :label="'Ampliar '+item.institucioneducativa+': '+(item.ampliar?'Si':'No')"
                    v-model="item.ampliar"
                    class="mt-1"
                  ></v-switch>
                  <div v-if="item.ampliar">
                    <v-card-title class="grey lighten-4 pa-1">
                      <h4 class="grey--text text--darken-1">Curso de Capacitación</h4>
                      <v-spacer></v-spacer>
                      <v-btn
                        flat
                        small
                        outline
                        color="primary my-0"
                        @click="showDialogCurso(indexss)"
                      >
                        Agregar Curso
                      </v-btn>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-data-table
                      :headers="headerCurso"
                      :items="item.cursos"
                      class="elevation-1 mb-3"
                      no-data-text="No existen registros"
                      hide-actions
                    >
                      <template v-slot:items="propc">
                        <td>{{ propc.index + 1 }}</td>
                        <td>{{ propc.item.curso_nombre }}</td>
                        <td>{{ propc.item.carga_horaria }}</td>
                        <td>{{ propc.item.tiempo }}</td>
                        <td>
                          <v-btn-toggle>
                            <v-btn
                              v-if="propc.item.turno_m"
                              small
                              class="transparent"
                            >
                              Mañana
                            </v-btn>
                            <v-btn
                              v-if="propc.item.turno_t"
                              small
                              class="transparent"
                            >
                              Tarde
                            </v-btn>
                            <v-btn
                              v-if="propc.item.turno_n"
                              small
                              class="transparent"
                            >
                              Noche
                            </v-btn>
                          </v-btn-toggle>
                        </td>
                        <td>
                          <v-tooltip bottom>
                            <template v-slot:activator="{on}">
                              <v-btn v-if="propc.item.eliminar"
                                v-on="on"
                                icon
                                dark
                                small
                                color="red"
                                @click="removeCurso(indexss, propc.index, 1)"
                              >
                                <v-icon small>delete</v-icon>
                              </v-btn>
                            </template>
                            <span>Quitar registro</span>
                          </v-tooltip>
                        </td>
                      </template>
                    </v-data-table>
                  </div>
                </div>
                <div v-if="datos.ampliacion.subsede.length == 0">
                  <h4 class="red--text text--lighten-1">No existen subsedes</h4>
                </div>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
        <v-card class="mb-3" v-if="datos.tipo_tramite.includes(4)">
          <v-card-title>
            <span class="title font-weight-bold blue--text text--darken-3">Cambio de Razón Social</span>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                  label="Anterior Razón Social"
                  v-model="datos.razon_social.nombre_anterior"
                  readonly
                  disabled
                  hide-details
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  label="Nueva Razón Social"
                  v-model.trim="datos.razon_social.nombre"
                  :rules="[v => !!v || 'El campo es requerido']"
                  class="txt-upper"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
        <v-card class="mb-3" v-if="datos.tipo_tramite.includes(5)">
          <v-card-title>
            <span class="title font-weight-bold blue--text text--darken-3">Cambio de Domicilio</span>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <h3 class="grey--text text--darken-1">Sede Central</h3>
            <v-layout row wrap>
              <v-flex xs12 class="py-1">
                <v-switch
                  label="Cambiar"
                  v-model="datos.domicilio.central.cambiar_direccion"
                ></v-switch>
              </v-flex>
              <v-flex xs12 sm8 class="py-0">
                <v-text-field
                  label="Anterior Dirección"
                  :value="datos.domicilio.direccion"
                  readonly
                  disabled
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm4 class="py-0">
                <v-text-field
                  label="Departamento"
                  :value="datos.domicilio.central.departamento"
                  readonly
                  disabled
                ></v-text-field>
              </v-flex>
              <v-flex xs6 md6 lg4 class="py-0" v-if="datos.domicilio.central.cambiar_direccion">
                <v-select
                  :items="provincias"
                  label="Provincia"
                  item-text="lugar"
                  item-value="id"
                  v-model="datos.domicilio.central.provincia_id"
                  @change="getMunicipios(datos.domicilio.central.provincia_id)"
                  :disabled="!datos.domicilio.central.cambiar_direccion"
                  :rules="datos.domicilio.central.cambiar_direccion?[v => !!v || 'Seleccione una opción']:[true]"
                  required
                ></v-select>
              </v-flex>
              <v-flex xs6 md6 lg4 class="py-0" v-if="datos.domicilio.central.cambiar_direccion">
                <v-select
                  :items="municipios"
                  label="Municipio"
                  item-text="lugar"
                  item-value="id"
                  v-model="datos.domicilio.central.municipio_id"
                  @change="getComunidades(datos.domicilio.central.municipio_id)"
                  :disabled="!datos.domicilio.central.cambiar_direccion"
                  :rules="datos.domicilio.central.cambiar_direccion?[v => !!v || 'Seleccione una opción']:[true]"
                  required
                ></v-select>
              </v-flex>
              <v-flex xs12 md6 lg4 class="py-0" v-if="datos.domicilio.central.cambiar_direccion">
                <v-select
                  :items="comunidades"
                  label="Comunidad"
                  item-text="lugar"
                  item-value="id"
                  v-model="datos.domicilio.central.comunidad_id"
                  :disabled="!datos.domicilio.central.cambiar_direccion"
                  :rules="datos.domicilio.central.cambiar_direccion?[v => !!v || 'Seleccione una opción']:[true]"
                  required
                ></v-select>
              </v-flex>
              <v-flex xs12 sm6 class="py-0" v-if="datos.domicilio.central.cambiar_direccion">
                <v-text-field
                  label="Nueva Dirección"
                  v-model="datos.domicilio.central.actual_direccion"
                  :rules="datos.domicilio.central.cambiar_direccion?[v => !!v || 'El campo es requerido']:[true]"
                  :disabled="!datos.domicilio.central.cambiar_direccion"
                  :value="datos.domicilio.central.cambiar_direccion?'':datos.domicilio.central.actual_direccion=''"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm2 class="py-0" v-if="datos.domicilio.central.cambiar_direccion">
                <v-text-field
                  label="Nueva Zona"
                  v-model="datos.domicilio.central.actual_zona"
                  :rules="datos.domicilio.central.cambiar_direccion?[v => !!v || 'El campo es requerido']:[true]"
                  :disabled="!datos.domicilio.central.cambiar_direccion"
                  :value="datos.domicilio.central.cambiar_direccion?'':datos.domicilio.central.actual_zona=''"
                ></v-text-field>
              </v-flex>
              <!-- <v-flex xs12 sm5 class="py-0">
                <v-text-field
                  label="Anterior Dirección"
                  v-model="datos.domicilio.direccion"
                  readonly
                  disabled
                ></v-text-field>
              </v-flex> -->
              <v-flex xs12 sm4 class="pt-0 pb-1" v-if="datos.domicilio.central.cambiar_direccion">
                <v-text-field
                  type="text"
                  label="Geolocalización"
                  v-model="datos.domicilio.central.geolocalizacion"
                  append-icon="map"
                  readonly
                  :disabled="!datos.domicilio.central.cambiar_direccion"
                  @click="showDialogMap(-1)"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <h3 class="grey--text text--darken-1">Subsede(s)</h3>
            <div v-if="datos.domicilio.subsede.length > 0">
              <v-layout row wrap v-for="(subsede, index) in datos.domicilio.subsede" :key="index">
                <v-flex xs12 class="py-1">
                  <v-switch
                    :label="'Cambiar ' +subsede.institucioneducativa"
                    v-model="subsede.cambiar_direccion"
                  ></v-switch>
                </v-flex>
                <v-flex xs12 sm8 class="py-0">
                  <v-text-field
                    label="Anterior Dirección"
                    :value="subsede.anterior_direccion"
                    readonly
                    disabled
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 class="py-0">
                  <v-text-field
                    label="Departamento"
                    :value="datos.domicilio.central.departamento"
                    readonly
                    disabled
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 md6 lg4 class="py-0" v-if="subsede.cambiar_direccion">
                  <v-select
                    :items="provincias"
                    label="Provincia"
                    item-text="lugar"
                    item-value="id"
                    v-model="subsede.provincia_id"
                    @change="getMunicipios(subsede.provincia_id)"
                    :disabled="!subsede.cambiar_direccion"
                    :rules="subsede.cambiar_direccion?[v => !!v || 'Seleccione una opción']:[true]"
                    required
                  ></v-select>
                </v-flex>
                <v-flex xs6 md6 lg4 class="py-0" v-if="subsede.cambiar_direccion">
                  <v-select
                    :items="municipios"
                    label="Municipio"
                    item-text="lugar"
                    item-value="id"
                    v-model="subsede.municipio_id"
                    @change="getComunidades(subsede.municipio_id)"
                    :disabled="!subsede.cambiar_direccion"
                    :rules="subsede.cambiar_direccion?[v => !!v || 'Seleccione una opción']:[true]"
                    required
                  ></v-select>
                </v-flex>
                <v-flex xs12 md6 lg4 class="py-0" v-if="subsede.cambiar_direccion">
                  <v-select
                    :items="comunidades"
                    label="Comunidad"
                    item-text="lugar"
                    item-value="id"
                    v-model="subsede.comunidad_id"
                    :disabled="!subsede.cambiar_direccion"
                    :rules="subsede.cambiar_direccion?[v => !!v || 'Seleccione una opción']:[true]"
                    required
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm6 class="py-0" v-if="subsede.cambiar_direccion">
                  <v-text-field
                    label="Nueva Dirección"
                    v-model="subsede.actual_direccion"
                    :rules="subsede.cambiar_direccion?[v => !!v || 'El campo es requerido']:[true]"
                    :disabled="!subsede.cambiar_direccion"
                    :value="subsede.cambiar_direccion?'':subsede.actual_direccion=''"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm2 class="py-0" v-if="subsede.cambiar_direccion">
                  <v-text-field
                    label="Nueva Zona"
                    v-model="subsede.actual_zona"
                    :rules="subsede.cambiar_direccion?[v => !!v || 'El campo es requerido']:[true]"
                    :disabled="!subsede.cambiar_direccion"
                    :value="subsede.cambiar_direccion?'':subsede.actual_zona=''"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 class="pt-0 pb-1" v-if="subsede.cambiar_direccion">
                  <v-text-field
                    type="text"
                    label="Geolocalización"
                    v-model="subsede.geolocalizacion"
                    append-icon="map"
                    readonly
                    :disabled="!subsede.cambiar_direccion"
                    @click="showDialogMap(index)"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </div>
            <div v-else>
              <h4 class="red--text text--lighten-1">No existen subsede</h4>
            </div>
          </v-card-text>
        </v-card>
        <v-card class="mb-3" v-if="datos.tipo_tramite.includes(6)">
          <v-card-title>
            <span class="title font-weight-bold blue--text text--darken-3">Cambio de Derecho Propietario</span>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 class="py-1">
                <v-text-field
                  label="Anterior Propietario"
                  v-model="datos.derecho_propietario.propietario_anterior"
                  readonly
                  disabled
                  hide-details
                ></v-text-field>
              </v-flex>
            </v-layout>
            <h3 class="grey--text text--darken-1 mt-2">Datos de Nuevo Propietario</h3>
            <v-layout row wrap>
              <v-flex xs12 sm4 class="py-1">
                <v-text-field
                  label="Nombres"
                  v-model.trim="datos.derecho_propietario.nombre"
                  :rules="[v => !!v || 'El campo es requerido']"
                  @keypress="isText($event)"
                  class="txt-upper"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 sm4 class="py-1">
                <v-text-field
                  label="Apellido Paterno"
                  v-model.trim="datos.derecho_propietario.paterno"
                  @keypress="isText($event)"
                  class="txt-upper"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 sm4 class="py-1">
                <v-text-field
                  label="Apellido Materno"
                  v-model.trim="datos.derecho_propietario.materno"
                  @keypress="isText($event)"
                  class="txt-upper"
                ></v-text-field>
              </v-flex>
              <v-flex xs7 sm3 class="py-1">
                <v-text-field
                  label="Cédula de Identidad"
                  v-model.trim="datos.derecho_propietario.cedula_identidad"
                  :rules="[v => !!v || 'El campo es requerido', v => (!!v && v.length > 3) || 'Mínimo 4 dígitos']"
                ></v-text-field>
              </v-flex>
              <v-flex xs5 sm3 class="py-1">
                <v-text-field
                  label="Complemento"
                  v-model.trim="datos.derecho_propietario.complemento"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 sm3 class="py-0">
                <v-select
                  :items="expedidos"
                  label="Expedido"
                  item-text="sigla"
                  item-value="id"
                  v-model="datos.derecho_propietario.expedido"
                  :rules="[v => !!v || 'Seleccione una opción']"
                  required
                ></v-select>
              </v-flex>
              <v-flex xs6 sm3 class="py-1">
                <v-btn
                  flat
                  :loading="loadingSegip"
                  outline
                  type="button"
                  color="primary"
                  @click="validarSegip(datos.derecho_propietario)">Validar SEGIP</v-btn>
              </v-flex>
              <v-flex xs12 md6 lg6 class="py-0">
                <v-text-field
                  type="text"
                  label="Dirección"
                  v-model="datos.derecho_propietario.direccion"
                  :rules="[v => !!v || 'El campo es requerido']"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs6 md3 lg3 class="py-0">
                <v-autocomplete
                  label="País"
                  :items="paises"
                  item-value="id"
                  item-text="pais"
                  v-model="datos.derecho_propietario.pais_id"
                  :rules="[v => !!v || 'Seleccione una opción']"
                  @change="getDepartamentos(datos.derecho_propietario.pais_id, 1)"
                  required
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6 md3 lg3 class="py-0">
                <v-select
                  :items="departamentos1"
                  label="Departamento"
                  item-text="lugar"
                  item-value="id"
                  v-model="datos.derecho_propietario.departamento_id"
                  :rules="[v => !!v || 'Seleccione una opción']"
                  required
                ></v-select>
              </v-flex>
              <v-flex xs12 md4 class="py-0">
                <v-menu
                  v-model="fechaNacProp"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="datos.derecho_propietario.fecha_nacimiento"
                      label="Fecha de Nacimiento"
                      append-icon="event"
                      :rules="[v => !!v || 'El campo es requerido']"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker locale v-model="datos.derecho_propietario.fecha_nacimiento" @input="fechaNacProp = false"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs6 md4 class="py-0">
                <v-select
                  :items="generos"
                  label="Genero"
                  item-text="genero"
                  item-value="id"
                  v-model="datos.derecho_propietario.genero_tipo_id"
                  :rules="[v => !!v || 'Seleccione una opción']"
                  required
                ></v-select>
              </v-flex>
              <!-- <v-flex xs6 md4 class="py-0">
                <v-select
                  :items="estado_civiles"
                  label="Estado Civil"
                  item-text="estado_civil"
                  item-value="id"
                  v-model="datos.derecho_propietario.estadocivil_tipo_id"
                  :rules="[v => !!v || 'Seleccione una opción']"
                  required
                ></v-select>
              </v-flex> -->
            </v-layout>
          </v-card-text>
        </v-card>
        <v-card class="mb-3" v-if="datos.tipo_tramite.includes(7)">
          <v-card-title>
            <span class="title font-weight-bold blue--text text--darken-3">Cierre del Centro de Capacitación</span>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 sm6>
                <h3 class="grey--text text--darken-1">Sede Central</h3>
                <v-switch
                  :label="'Cerrar: '+(datos.cierre_centro.central.cerrar?'Si':'No')"
                  v-model="datos.cierre_centro.central.cerrar"
                  class="mt-1"
                ></v-switch>
              </v-flex>
              <v-flex xs12 sm6>
                <h3 class="grey--text text--darken-1">Subsede(s)</h3>
                <div v-if="datos.cierre_centro.subsede.length > 0">
                  <v-switch
                    v-for="(item, index) in datos.cierre_centro.subsede" :key="index"
                    :label="'Cerrar '+item.institucioneducativa+': '+(item.cerrar?'Si':'No')"
                    v-model="item.cerrar"
                    class="mt-1"
                  ></v-switch>
                  <!-- :value="datos.cierre_centro.central.cerrar==true?item.cerrar=true:item.cerrar=false" -->
                </div>
                <div v-else>
                  <h4 class="red--text text--lighten-1">No existen subsede</h4>
                </div>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 sm6>
                <v-select
                  label="Motivo del Cierre"
                  :items="motivo_cierre"
                  item-value="id"
                  item-text="descripcion"
                  v-model="datos.cierre_centro.motivo"
                  :rules="[v => !!v || 'Seleccione una opción']"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm6>
                <v-checkbox
                  v-model="datos.cierre_centro.logro_objetivo"
                  label="Logró los objetivos?"
                ></v-checkbox>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  label="Cantidad de Participantes Capacitados"
                  v-model.trim="datos.cierre_centro.cantidad_capacitado"
                  :rules="[v => !!v || 'El campo es requerido']"
                  @keydown="isNumber($event)"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  label="Cantidad de Certificados entregados"
                  v-model.trim="datos.cierre_centro.cantidad_certificado"
                  :rules="[v => !!v || 'El campo es requerido']"
                  @keydown="isNumber($event)"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
        <v-card v-if="datos.tipo_tramite.includes(2) || datos.tipo_tramite.includes(3) || datos.tipo_tramite.includes(4) || datos.tipo_tramite.includes(5) || datos.tipo_tramite.includes(6) || datos.tipo_tramite.includes(7)">
          <v-card-title>
            <!-- <h3 class="grey--text text--darken-1">Requisitos</h3> -->
            <span class="title font-weight-bold blue--text text--darken-3">Requisitos</span>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 md6 class="py-1">
                <v-checkbox
                  v-model="datos.requisito.nota_solicitud"
                  label="Nota de Solicitud"
                  :rules="[v => !!v || 'Marque la opción']"
                  class="my-0 py-0"
                ></v-checkbox>
              </v-flex>
              <v-flex xs12 md6 class="py-1" v-if="datos.tipo_tramite.includes(2) || datos.tipo_tramite.includes(3) || datos.tipo_tramite.includes(4) || datos.tipo_tramite.includes(5) || datos.tipo_tramite.includes(6)">
                <v-checkbox
                  label="C.I. Propietario/Representante legal"
                  v-model="datos.requisito.ci_propietario_representante"
                  class="my-0 py-0"
                ></v-checkbox>
              </v-flex>
              <v-flex xs12 md6 class="py-1" v-if="datos.tipo_tramite.includes(2) || datos.tipo_tramite.includes(3) || datos.tipo_tramite.includes(4) || datos.tipo_tramite.includes(6)">
                <v-checkbox
                  label="NIT"
                  v-model="datos.requisito.nit"
                  class="my-0 py-0"
                ></v-checkbox>
              </v-flex>
              <v-flex xs12 md6 class="py-1" v-if="datos.tipo_tramite.includes(2) || datos.tipo_tramite.includes(3) || datos.tipo_tramite.includes(4) || datos.tipo_tramite.includes(6)">
                <v-checkbox
                  label="FUNDEMPRESA"
                  v-model="datos.requisito.fundempresa"
                  class="my-0 py-0"
                ></v-checkbox>
              </v-flex>
              <v-flex xs12 md6 class="py-1" v-if="datos.tipo_tramite.includes(2) || datos.tipo_tramite.includes(3) || datos.tipo_tramite.includes(4) || datos.tipo_tramite.includes(5) || datos.tipo_tramite.includes(6)">
                <v-checkbox
                  label="Poder Notarial (si corresponde)"
                  v-model="datos.requisito.poder_notarial"
                  class="my-0 py-0"
                ></v-checkbox>
              </v-flex>
              <v-flex xs12 md6 class="py-1" v-if="datos.tipo_tramite.includes(2) || datos.tipo_tramite.includes(3) || datos.tipo_tramite.includes(5)">
                <v-checkbox
                  label="Folio Real (propietario)/form. información rápida(inquilino)"
                  v-model="datos.requisito.folio_real"
                  class="my-0 py-0"
                ></v-checkbox>
              </v-flex>
              <v-flex xs12 md6 class="py-1" v-if="datos.tipo_tramite.includes(2) || datos.tipo_tramite.includes(3) || datos.tipo_tramite.includes(5)">
                <v-checkbox
                  label="Contrato de Alquiler (original/fotocopia legalizada)"
                  v-model="datos.requisito.contrato_alquiler"
                  class="my-0 py-0"
                ></v-checkbox>
              </v-flex>
              <v-flex xs12 md6 class="py-1" v-if="datos.tipo_tramite.includes(4) || datos.tipo_tramite.includes(5) || datos.tipo_tramite.includes(6) || datos.tipo_tramite.includes(7)">
                <v-checkbox
                  label="Resolución Ministerial (fotocopia legalizada)"
                  v-model="datos.requisito.resolucion_ministerial"
                  class="my-0 py-0"
                ></v-checkbox>
              </v-flex>
              <v-flex xs12 md6 class="py-1" v-if="datos.tipo_tramite.includes(2) || datos.tipo_tramite.includes(3) || datos.tipo_tramite.includes(5)">
                <v-checkbox
                  label="Plano de Infraestructura"
                  v-model="datos.requisito.plano_infraestructura"
                  class="my-0 py-0"
                ></v-checkbox>
              </v-flex>
              <v-flex xs12 md6 class="py-1" v-if="datos.tipo_tramite.includes(4)">
                <v-checkbox
                  label="Testimonio o Estatuto de constitución (fotocopia legalizada)"
                  v-model="datos.requisito.testimonio_estatuto"
                  class="my-0 py-0"
                ></v-checkbox>
              </v-flex>
              <v-flex xs12 md6 class="py-1" v-if="datos.tipo_tramite.includes(6)">
                <v-checkbox
                  label="Testimonio de Acticipo de legitima/Declaratoria de Heredero"
                  v-model="datos.requisito.testimonio_declaratoria"
                  class="my-0 py-0"
                ></v-checkbox>
              </v-flex>
              <v-flex xs12 md6 class="py-1" v-if="datos.tipo_tramite.includes(7)">
                <v-checkbox
                  label="Resolución Ministerial (infracción)"
                  v-model="datos.requisito.resolucion_ministerial_infraccion"
                  class="my-0 py-0"
                ></v-checkbox>
              </v-flex>
              <v-flex xs12 md6 class="py-1" v-if="datos.tipo_tramite.includes(7)">
                <v-checkbox
                  label="Informe de Conclusión de Cursos de Capacitación"
                  v-model="datos.requisito.informe_conclusion"
                  class="my-0 py-0"
                ></v-checkbox>
              </v-flex>
              <v-flex xs12 md6 class="py-1" v-if="datos.tipo_tramite.includes(7)">
                <v-checkbox
                  label="Centralizadores de Capacitación y Boletines de Notas"
                  v-model="datos.requisito.centralizador_boletin"
                  class="my-0 py-0"
                ></v-checkbox>
              </v-flex>
              <v-flex xs12 md6 class="py-1" v-if="datos.tipo_tramite.includes(7)">
                <v-checkbox
                  label="Aspectos Pendientes"
                  v-model="datos.requisito.aspecto_pendiente"
                  class="my-0 py-0"
                ></v-checkbox>
              </v-flex>
            </v-layout>
            <div v-if="datos.tipo_tramite.includes(2) || datos.tipo_tramite.includes(3)">
              <h3 class="grey--text text--darken-1">Proyecto Educativo Institucional</h3>
              <v-divider></v-divider>
              <v-layout row wrap>
                <v-flex xs12 sm6 md6>
                  <h4 class="grey--text text--darken-2 mb-2">Documentos Institucionales</h4>
                  <v-checkbox v-model="datos.pei.reglamento_interno" label="Reglamento Interno" class="my-0 py-1"></v-checkbox>
                  <v-checkbox v-model="datos.pei.infraestructura" label="Infraestructura" class="my-0 py-1"></v-checkbox>
                  <v-checkbox v-model="datos.pei.espacio_administrativo" label="Espacio Administrativo" class="my-0 py-1"></v-checkbox>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <h4 class="grey--text text--darken-2 mb-2">Equipamiento</h4>
                  <v-checkbox v-model="datos.pei.maquinaria_equipo" label="Maquinaria y Equipos" class="my-0 py-1"></v-checkbox>
                  <v-checkbox v-model="datos.pei.herramienta" label="Herramientas" class="my-0 py-1"></v-checkbox>
                  <v-checkbox v-model="datos.pei.instrumento" label="Instrumentos" class="my-0 py-1"></v-checkbox>
                  <v-checkbox v-model="datos.pei.tarjeta_propiedad" label="Tarjeta de Propiedad (caso de autoescuela)" class="my-0 py-1"></v-checkbox>
                </v-flex>
              </v-layout>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary darken-1"
              @click.native="confirmTramite"
            >
              Guardar
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-form>
      <v-dialog v-model="dialogCurso" scrollable :width="(size_width>1024?'60%':'100%')">
        <v-card>
          <v-card-title class="headline grey lighten-3" primary-title>
            <span class="headline">Agregar Curso</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-lg fluid class="py-1">
              <v-form ref="form_curso">
                <v-layout row wrap>
                  <v-flex xs12 class="py-0">
                    <v-autocomplete
                      :items="facilitadores"
                      label="Facilitadores"
                      item-text="nombre"
                      item-value="id"
                      v-model="curso.facilitador_id"
                      :rules="[v => !!v || 'Seleccione una opción']"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 sm6 class="py-0">
                    <v-autocomplete
                      :items="cursos"
                      label="Curso"
                      item-text="curso"
                      item-value="id"
                      v-model="curso.curso_capacitacion"
                      :rules="[v => !!v || 'Seleccione una opción']"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs6 sm3 class="py-0">
                    <v-text-field
                      type="text"
                      label="Carga Horaria"
                      v-model.trim="curso.carga_horaria"
                      :rules="[v => !!v || 'El campo es requerido', v => (!!v && v > 19) || 'Valor mínimo 20', v => (!!v && v < 301) || 'Valor máximo 300']"
                      @keypress="isNumber($event)"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm3 class="py-0">
                    <v-text-field
                      type="text"
                      label="Tiempo"
                      v-model.trim="curso.tiempo"
                      :rules="[v => !!v || 'El campo es requerido', v => (!!v && v > 0) || 'Valor mínimo 1', v => (!!v && v < 5) || 'Valor máximo 4']"
                      @keypress="isNumber($event)"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 class="my-0 pb-0">
                    <h3 class="grey--text text--darken-1">Turno</h3>
                  </v-flex>
                  <v-flex xs12 sm4 md4 class="py-0">
                    <v-checkbox
                      class="my-0"
                      v-model="curso.turno_m"
                      label="Mañana"
                      hide-details
                    ></v-checkbox>
                  </v-flex>
                  <v-flex xs12 sm4 md4 class="py-0">
                    <v-checkbox
                      class="my-0"
                      v-model="curso.turno_t"
                      label="Tarde"
                      hide-details
                    ></v-checkbox>
                  </v-flex>
                  <v-flex xs12 sm4 md4 class="py-0">
                    <v-checkbox
                      class="my-0"
                      v-model="curso.turno_n"
                      label="Noche"
                      hide-details
                    ></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success darken-1" flat @click="agregarCurso">
              Agregar
            </v-btn>
            <v-btn color="blue darken-1" flat @click="dialogCurso = false">
              Cerrar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogMap" persistent :width="(size_width>1024?'51%':'90%')">
        <v-card>
          <v-card-title class="headline grey lighten-3">
            <span class="headline">Geolocalización</span>
          </v-card-title>
          <v-card-text class="text-xs-center">
            <p class="grey--text text--darken-2">Marque la ubicación del Centro de Capacitación Técnica Privado.</p>
            <div id="geomap" style="width: 100% !important; height: 50vh"></div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="dialogMap = false">
              Cerrar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="cdialog" persistent width="300">
        <v-card>
          <v-card-title class="headline grey lighten-3" primary-title>
            <span class="headline">Alerta</span>
          </v-card-title>
          <v-card-text class="text-xs-center">
            <p :class="color_txt + '--text text--darken-2 subheading'">
              {{ message }}
            </p>
            <v-btn
              v-if="hide_accept == false && (datos.tipo_tramite.includes(2) || datos.tipo_tramite.includes(3) || datos.tipo_tramite.includes(4) || datos.tipo_tramite.includes(5) || datos.tipo_tramite.includes(6) )"
              outline
              color="primary"
              @click="formularioCctp"
              class="mt-3"
            >
              Imprimir Formulario
            </v-btn>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              :loading="loadingBtnSend"
              v-if="hide_accept"
              color="success darken-1"
              flat
              @click="createTramites"
            >
              Aceptar
            </v-btn>
            <v-btn color="blue darken-1" flat @click="closeDialog">
              Cerrar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-snackbar
        v-model="snack.state"
        top
        right
        :timeout="2500"
        :color="snack.color"
        :multi-line="snack.mode === 'multi-line'"
      >
        {{ snack.text }}
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import Service from "../services/general";
import DatosCentro from '@/components/DatosCentro'
import axios from "axios";
export default {
  name: 'inicio-tramite',
  components: {
    DatosCentro,
  },
  data: () => ({
    loadingBtnSend: false,
    loadingSegip: false,
    fechaNacProp: false,
    loadingPrint: false,
    headerCurso: Service.headerTable().curso,
    datos: {
      institucioneducativa_id: '',
      tipo_tramite: [],
      tramite_id: '',
      devolucion: 0,
      ratificacion: {
        central: {
          ratificar: false,
          cursos: []
        },
        subsede: []
      },
      ampliacion: {
        central: {
          ampliar: false,
          cursos: []
        },
        subsede: []
      },
      razon_social: {
        nombre_anterior: '',
        nombre: ''
      },
      domicilio: {
        central: {
          cambiar_direccion: false,
          departamento: '',
          departamento_id: '',
          provincia_id: '',
          municipio_id: '',
          comunidad_id: '',
          anterior_direccion: '',
          actual_direccion: '',
          geolocalizacion: ''
        },
        subsede: []
      },
      derecho_propietario: {
        propietario_anterior: '',
        apropietario_id: '',
        nombre: '',
        paterno: '',
        materno: '',
        cedula_identidad: '',
        complemento: '',
        expedido: '',
        genero_tipo_id: '',
        estadocivil_tipo_id: '',
        fecha_nacimiento: '',
        pais_id: '',
        departamento_id: '',
        direccion: '',
        segip_id: ''
      },
      cierre_centro: {
        central: {
          cerrar: false
        },
        subsede: [],
        motivo: '',
        logro_objetivo: '',
        cantidad_capacitado: '',
        cantidad_certificado: ''
      },
      requisito: {
        nota_solicitud: false,
        ci_propietario_representante: false,
        nit: false,
        fundempresa: false,
        poder_notarial: false,
        folio_real: false,
        contrato_alquiler: false,
        resolucion_ministerial: false,
        plano_infraestructura: false,
        testimonio_estatuto: false,
        testimonio_declaratoria: false,
        resolucion_ministerial_infraccion: false,
        informe_conclusion: false,
        centralizador_boletin: false,
        aspecto_pendiente: false
      },
      pei: {
        reglamento_interno: false,
        infraestructura: false,
        espacio_administrativo: false,
        maquinaria_equipo: false,
        herramienta: false,
        instrumento: false,
        tarjeta_propiedad: false
      }
    },
    tipos_tramite: [],
    motivo_cierre: [],
    tipo_contratos: [],
    paises: [],
    departamentos: [],
    departamentos1: [],
    provincias: [],
    municipios: [],
    comunidades: [],
    expedidos: [],
    generos: [],
    estado_civiles: [],
    cursos: [],
    facilitadores: [],
    curso: {
      facilitador_id: '',
      curso_nombre: '',
      curso_capacitacion: '',
      carga_horaria: '',
      tiempo: '',
      turno_m: false,
      turno_t: false,
      turno_n: false,
      eliminar: true
    },
    central_subsede: '',
    observacion: '',
    dialogCurso: false,
    size_width: 0,
    cdialog: false,
    dialogMap: false,
    hide_accept: false,
    color_txt: '',
    message: '',
    dparams: {},
    tramite_id: '',
    sede_subsede: -1,
    map: null,
    snack: {
      state: false,
      color: 'success',
      mode: '',
      text: ''
    }
  }),
  mounted() {
    this.dparams = Service.getParams();
    if (this.dparams && this.dparams.roluser != Service.rol().director) {
      this.$router.push({name: 'principal'});
    }
    if (this.dparams != null) {
      this.getPaises();
      this.getDepartamentos(1, 0);
      this.getExpedidos(1);
      this.getGeneroEstadoCivil();
      let self = this;
      var lmarker, cmarker;
      this.map = new mapboxgl.Map({
        container: 'geomap',
        style: 'mapbox://styles/mapbox/streets-v11',
        center: [-63.588654, -16.290154], 
        zoom: 4
      });
      this.map.addControl(new MapboxGeocoder({
        accessToken: mapboxgl.accessToken,
        mapboxgl: mapboxgl,
        countries: 'bo',
        placeholder: 'Buscar lugar',
        zoom: 11
      }));
      this.map.addControl(new mapboxgl.NavigationControl());
      this.map.doubleClickZoom.disable();
      this.map.on('click', ev => {
        if (lmarker)
          lmarker.remove();
        cmarker = new mapboxgl.Marker()
        .setLngLat([ev.lngLat.lng, ev.lngLat.lat])
        .addTo(this.map);
        if (this.sede_subsede == -1) {
          self.datos.domicilio.central.geolocalizacion = JSON.stringify([ev.lngLat.lat, ev.lngLat.lng]);
        } else {
          self.datos.domicilio.subsede[this.sede_subsede].geolocalizacion = JSON.stringify([ev.lngLat.lat, ev.lngLat.lng]);
        }
        lmarker = cmarker;
      });
    }
    this.$nextTick(() => {
      window.addEventListener('resize', this.getWidth);
      this.getWidth();
    });
    this.tipos_tramite = [
      {id: 2, descripcion: 'Ratificación', ruta: 'ratificacion'},
      {id: 3, descripcion: 'Ampliación', ruta: 'ampliacion'},
      {id: 4, descripcion: 'Cambio de Razón Social', ruta: 'cambio/nombre'},
      {id: 5, descripcion: 'Cambio de Domicilio', ruta: 'cambio/domicilio'},
      {id: 6, descripcion: 'Cambio de Derecho Propietario', ruta: 'cambio/propietario'},
      {id: 7, descripcion: 'Cierre del Centro de Capacitación', ruta: 'cierre/centro'}
    ];
    this.motivo_cierre = [
      { id: 1, descripcion: "Voluntario" },
      { id: 2, descripcion: "Infracción" }
    ];
    this.tipo_contratos = Service.tipoContrato();
    //console.log(Service.getTramiteId());
    if (Service.getTramiteId() != null) {
      this.datos.tramite_id = Service.getTramiteId();
      this.datos.devolucion = 1;
      this.getDatos(this.datos.tramite_id);
    }
  },
  methods: {
    getWidth() {
      this.size_width = document.documentElement.clientWidth;
    },
    changeTipoTramite() {
      let cantidad = this.datos.tipo_tramite.length;
      if ((this.datos.tipo_tramite.includes(2) || this.datos.tipo_tramite.includes(3) || this.datos.tipo_tramite.includes(4) || this.datos.tipo_tramite.includes(5) || this.datos.tipo_tramite.includes(6)) && this.datos.tipo_tramite[cantidad-1]!=7) {//&& !this.datos.tipo_tramite.includes(7)
        let indexV = this.datos.tipo_tramite.indexOf(7);
        if (indexV != -1) {
          this.datos.tipo_tramite.splice(indexV, 1);
        }
      }
      if (this.datos.tipo_tramite.includes(7)) {
        this.datos.tipo_tramite = [7];
      }
    },
    getInformacionCentro() {
      axios
        .get(Service.getBase() + "informacion/centro/"+this.dparams.ie_id, Service.getHeader())
        .then(response => {
          let dpto_id = this.departamentos.findIndex(x => x.id === response.data.localizacion.lugar_tipo_id_localidad);
          this.datos.domicilio.central.departamento = this.departamentos[dpto_id].lugar;
          this.datos.domicilio.central.departamento_id = response.data.localizacion.lugar_tipo_id_localidad;
          this.datos.razon_social.nombre_anterior = response.data.centro.institucioneducativa;
          this.datos.domicilio.direccion = response.data.localizacion.direccion;
          this.datos.derecho_propietario.propietario_anterior = (response.data.propietario.persona.nombre+' '+response.data.propietario.persona.paterno+' '+response.data.propietario.persona.materno);
          this.datos.derecho_propietario.apropietario_id =  response.data.propietario.persona_id;
          
          this.getProvincias(response.data.localizacion.lugar_tipo_id_localidad);
          this.datos.domicilio.subsede = response.data.subsede;
          this.datos.ratificacion.subsede = response.data.subsede;
          this.datos.ampliacion.subsede = response.data.subsede;
          this.datos.cierre_centro.subsede = response.data.subsede;
        })
        .catch(error => {
          console.error("Error al cargar registros", error);
        });
    },
    getPaises() {
      axios.get(Service.getServe() + 'out/pais').then(response => {
        this.paises = response.data;
      }).catch(error => {
        console.error('Error al cargar datos', error);
      });
    },
    getExpedidos(pais_id) {
      Service.expedidos(pais_id).then(response => {
        this.expedidos = response.data;
      }).catch(error => {
        console.error('Error al cargar datos', error);
      });
    },
    getDepartamentos(pais_id, tipo) {
      Service.lugarTipo(Service.nivel().departamento, pais_id).then(response => {
        if (tipo == 0) {
          this.departamentos = response.data;
          this.getInformacionCentro();
        } else if (tipo == 1) {
          this.departamentos1 = response.data;
        }
      }).catch(error => {
        console.error('Error al cargar datos', error);
      });
    },
    getProvincias(departamento_id) {
      Service.lugarTipo(Service.nivel().provincia, departamento_id).then(response => {
        this.provincias = response.data;
      }).catch(error => {
        console.error('Error al cargar datos', error);
      });
    },
    getMunicipios(provincia_id) {
      Service.lugarTipo(Service.nivel().municipio, provincia_id).then(response => {
        this.municipios = response.data;
      }).catch(error => {
        console.error('Error al cargar datos', error);
      });
    },
    getComunidades(municipio_id) {
      Service.lugarTipo(Service.nivel().comunidad, municipio_id).then(response => {
        this.comunidades = response.data;
      }).catch(error => {
        console.error('Error al cargar datos', error);
      });
    },
    getGeneroEstadoCivil() {
      Service.generoEstadoCivil().then(response => {
        this.generos = response.data.genero;
        this.estado_civiles = response.data.estado_civil;
      }).catch(error => {
        console.error('Error al cargar datos', error);
      });
    },
    getCursosFacilitadores() {
      Service.cursosFacilitadores(this.dparams.ie_id).then(response => {
        this.cursos = response.data.cursos;
        this.facilitadores = response.data.facilitadores;
      }).catch(error => {
        console.error('Error al cargar datos', error);
      });
    },
    showDialogCurso(central_subsede) {
      this.central_subsede = central_subsede;
      this.$refs.form_curso.reset();
      this.dialogCurso = true;
      this.getCursosFacilitadores();
    },
    agregarCurso() {
      if(this.$refs.form_curso.validate()) {
        if ((this.curso.turno_m == undefined || this.curso.turno_m == false) && (this.curso.turno_t == undefined || this.curso.turno_t == false) && (this.curso.turno_n == undefined || this.curso.turno_n == false)) {
          this.toast('warning', 'Marque por lo menos una o todos los turnos.');
        } else {
          let curso_id = this.cursos.findIndex(x => x.id === this.curso.curso_capacitacion);
          this.curso.curso_nombre = this.cursos[curso_id].curso;
          if(this.central_subsede == -1) {
            this.datos.ampliacion.central.cursos.push(this.curso);
          } else {
            this.datos.ampliacion.subsede[this.central_subsede].cursos.push(this.curso);
          }
          this.curso = {
            facilitador_id: '',
            curso_nombre: '',
            curso_capacitacion: '',
            carga_horaria: '',
            tiempo: '',
            turno_m: false,
            turno_t: false,
            turno_n: false,
            eliminar: true
          };
          this.dialogCurso = false;
        }
      }
    },
    removeCurso(central_subsede, posicion, tipo_curso_facilitador) {
      if (tipo_curso_facilitador == 1) {
        if (central_subsede == -1) {
          this.datos.ampliacion.central.cursos.splice(posicion, 1);
        } else {
          this.datos.ampliacion.subsede[central_subsede].cursos.splice(posicion, 1);
        }
      } else {
        if (central_subsede == -1) {
          this.datos.ampliacion.central.facilitadores.splice(posicion, 1);
        } else {
          this.datos.ampliacion.subsede[central_subsede].facilitadores.splice(posicion, 1);
        }
      }
    },
    validarSegip(propietario) {
      this.loadingSegip = true;
      if (propietario.cedula_identidad!='' && propietario.nombre!='' && (propietario.paterno!='' || propietario.materno!='')) {
        if (Service.validateSegip()) {
          Service.postValidarSegip(propietario).then(response => {
            this.loadingSegip = false;
            if (response.data.valido == 1) {
              propietario.segip_id = response.data.valido;
              propietario.paterno = response.data.persona.PrimerApellido;
              propietario.materno = response.data.persona.SegundoApellido;
              propietario.complemento = response.data.persona.Complemento;
              this.toast('success', response.data.msg);
            } else {
              this.toast('warning', response.data.msg);
            }
          }).catch(error => {
            this.loadingSegip = false;
          });
        }
      } else {
        this.loadingSegip = false;
        this.toast('warning', 'Ingrese la información necesaria para validar con SEGIP');
      }
    },
    showDialogMap(subsede_id) {
      this.sede_subsede = subsede_id;
      this.dialogMap = true;
    },
    confirmTramite() {
      if (this.$refs.form_datos.validate()) {
        // if (this.apertura.cursos_capacitacion.length > 0) {
          this.color_txt = 'grey';
          this.loadingBtnSend = false;
          this.hide_accept = true;
          this.message = '¿Está segura(o) de iniciar el/los trámite(s) con la información ingresada?';
          this.cdialog = true;
        // } else {
        //   this.toast('warning', 'Debe agregar el/los curso(s) de capacitación');
        // }
      } else {
        this.toast('warning', 'Debe completar los datos del formulario');
      }
    },
    createTramites() {
      this.loadingBtnSend = true;
      this.dparams.flujotipo_id = Service.getFlujoTipoId();
      this.dparams.tramite_id = this.datos.tramite_id;
      this.datos.institucioneducativa_id = this.dparams.ie_id;
      this.datos.razon_social.nombre = this.datos.razon_social.nombre.toUpperCase();
      axios
        .post(Service.getBase() + 'inicio/modificacion', {params: this.dparams, datos: JSON.stringify(this.datos)}, Service.getHeader())
        .then((response) => {
          this.loadingBtnSend = false;
          if (response.data.estado == 200) {
            this.color_txt = 'success';
            this.hide_accept = false;
            this.$refs.form_datos.reset();
            this.archivo_rm = null;
            this.tramite_id = response.data.tramite_id;
          } else {
            this.color_txt = 'error';
            this.hide_accept = true;
          }
          this.message = response.data.msg;
        })
        .catch((error) => {
          this.loadingBtnSend = false;
          this.color_txt = 'error';
          this.hide_accept = true;
          this.message = "No se pudo registrar el trámite";
          console.error("Error al guardar", error);
        });
    },
    closeDialog() {
      if (this.hide_accept == false) {
        Service.removeTramiteId();
        this.$router.push({name: 'tramite/recibido'});
      }
      this.cdialog = false;
    },
    formularioCctp() {//this.tramite_id = 1671390;//1671367;
      this.loadingPrint = true;
      axios.get(Service.getBase() + 'tramite/tarea/1/' + this.tramite_id, Service.getHeader()).then(response => {
        this.loadingPrint = false;
        var datos = JSON.parse(response.data.datos);
        Service.formularioCctpModifica(datos);
      }).catch(error => {
        console.error('Error al cargar datos', error);
      });
    },
    getDatos(tramite_id) {
      axios
        .get(Service.getBase() + "tramite/tareaobs/5/" + tramite_id, Service.getHeader())
        .then(async (response) => {
          if (response.data.datos !='') {
            this.observacion = response.data.observacion;
            // this.tarea = JSON.parse(response.data.datos);
            // this.datos.facilitadores = this.tarea.facilitadores;
            // this.datos.requisito = this.tarea.requisito;
          }
        })
        .catch(error => {
          console.error("Error al cargar registros", error);
        });
    },
    toast(color, text) {
      this.snack.color = color;
      this.snack.text = text;
      this.snack.state = true;
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getWidth);
  }
};
</script>